export type SearchFamilyGoupForDashboard = {
  FamilyGroup: string
}

export const initialValueOfSearchFamilyGoupForDashboard = {
  FamilyGroup: ""
}

export type SearchProductForDailyUpdatesDashboard = {
  UpdatedDate: string
}

export const initialValueOfSearchProductForDailyUpdatesDashboard:SearchProductForDailyUpdatesDashboard = {
  UpdatedDate: ""
}

export type SearchProductForMissingAttributesDashboard = {
  NewLine: boolean
}

export const initialValueOfSearchProductForMissingAttributesDashboard:SearchProductForMissingAttributesDashboard = {
  NewLine: false
}